/*
  Directional sticky header + logo compress.

  Toggles body.diesel-top / diesel-up / diesel-down and publishes
  --diesel-hdr-full, which the CSS uses to slide the header group out of view on
  scroll-down, bring it back shrunk on scroll-up, and restore it at the top of
  the page. The matching CSS lives in sections/main-collection-product-grid.liquid
  and is unscoped, so it applies wherever this script runs.

  Shared by every template that wants the behaviour — collection, the two denim
  guides and search. It used to be pasted inline into each of those sections,
  which is precisely how the same off-by-40px bug ended up in all three copies at
  once (see the setFullHeight comment). One file now, so a fix lands everywhere.

  Safe to load on pages without a header group: it returns early.
*/
(function () {
  var body = document.body;
  var headerGroup = document.querySelector('.shopify-section-group-header-group');
  var logo = document.querySelector('.site-header__logo');
  if (!headerGroup) return;

  function setFullHeight() {
    // Translate by the logo's BOTTOM edge measured from the top of the header
    // group -- NOT by the logo's own height. The logo starts below the 40px
    // announcement bar, so height alone left exactly that 40px unaccounted for
    // and the logo's red bottom edge stayed on screen (measured: needed 240px,
    // was translating 216px, leaving a 24px sliver).
    //
    // Page-absolute offsetTop sums are used deliberately: they are LAYOUT
    // values, so they are unaffected both by the group's own translateY and by
    // the scale() the logo gets in the diesel-up state -- either of which would
    // corrupt a getBoundingClientRect() reading. Walking to offsetParent rather
    // than to the group itself is required because the group is not positioned
    // and so never appears in the offsetParent chain.
    var pageTop = function (el) {
      var y = 0;
      while (el) {
        y += el.offsetTop;
        el = el.offsetParent;
      }
      return y;
    };
    var h = logo
      ? pageTop(logo) + logo.offsetHeight - pageTop(headerGroup)
      : headerGroup.offsetHeight;
    body.style.setProperty('--diesel-hdr-full', h + 2 + 'px');
  }

  setFullHeight();
  window.addEventListener('resize', setFullHeight);

  var lastY = window.pageYOffset || 0;
  var ticking = false;

  function update() {
    var y = window.pageYOffset || 0;
    if (y <= 10) {
      body.classList.add('diesel-top');
      body.classList.remove('diesel-down', 'diesel-up');
    } else {
      body.classList.remove('diesel-top');
      if (y > lastY + 5) {
        body.classList.add('diesel-down');
        body.classList.remove('diesel-up');
      } else if (y < lastY - 5) {
        body.classList.add('diesel-up');
        body.classList.remove('diesel-down');
      }
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();
